import React from 'react';
import { BsFolderPlus } from '@react-icons/all-files/bs/BsFolderPlus';

import { decorateComponent } from '../../../documentComponents';
import { StickyTabItem } from './StickyTabItem';
import { StickyTabItemInspector } from './StickyTabItem.Inspector';

const TextTabItemNode = {
  key: null,
  type: 'textTabItem',
  props: {},
  children: [],
};

export default decorateComponent(StickyTabItem, 'block', {
  id: 'stickyTabItem',
  label: '스티키 탭 항목',
  allowedParent: ['stickyTab'],
  allowedChildren: [],
  defaultProps: {
    children: [TextTabItemNode],
  },
  renderIcon: () => <BsFolderPlus />,
  renderInspector: StickyTabItemInspector,
});
